import { FC, useEffect } from 'react';
import dayjs from 'dayjs';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Async
import { getAccounts } from 'app/store/AccountsManagement/AccountsManagement.async';
import { getInvoices } from 'app/store/BillingInvoices/BillingInvoices.async';
import { getInvoicesSummary } from 'app/store/BillingInvoices/BillingInvoices.async';
// Actions
import { BillingInvoicesActions } from 'app/store/BillingInvoices/BillingInvoices.slice';
// Selectors
import { selectParams, selectValidateDateRange } from 'app/store/BillingInvoices/BillingInvoices.selectors';
// Mui
import { Box } from '@mui/material';
// 
import InvoicesSidebar from './InvoicesSidebar';
import InvoicesSummary from './InvoicesSummary';
import InvoicesList from './InvoicesList';
// ToDO: Should be reworked
import InvoicesQuckbooks from 'app/pages/Staff/CaseDetailsPage/InvoicesPage/InvoicesQuickbooks';

const BillingInvoicesTabContent:FC = () => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const params:any = useAppSelector(selectParams);
  const validationErrors = useAppSelector((state) => selectValidateDateRange(state, { isRequired: true }));

  useEffect(() => {
    dispatch(getAccounts({}));
    dispatch(BillingInvoicesActions.setParams({ dateRangeStart: dayjs().startOf('year'), dateRangeEnd: dayjs() }));

    return () => {
      dispatch(BillingInvoicesActions.setInitialField('invoices'));
      dispatch(BillingInvoicesActions.setInitialField('params'));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const { limit, offset, dateRangeStart, dateRangeEnd, ...otherParams } = params;

    if ( validationErrors ) return;

    const nextParams = {
      ...otherParams,
      dateRangeStart: dateRangeStart ? dateRangeStart.format('YYYY-MM-DD') : null,
      dateRangeEnd: dateRangeEnd ? dateRangeEnd.add(1, 'day').format('YYYY-MM-DD') : null
    };
    dispatch(getInvoices({...nextParams, limit, offset}));
    dispatch(getInvoicesSummary(nextParams));
    // eslint-disable-next-line
  }, [validationErrors, params]);

  return (
    <Box sx={{ height: '100%', display: 'flex' }} >
      <InvoicesSidebar />
      <Box sx={{ flexGrow: 1, p: 4, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 4 }}>
          <InvoicesSummary />
          <InvoicesQuckbooks />
        </Box>
        <InvoicesList />
      </Box>
    </Box>
  )
}

export default BillingInvoicesTabContent;
